var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.99999H3.4C2.55992 1.99999 2.13988 1.99999 1.81901 2.16348C1.53677 2.30729 1.3073 2.53676 1.16349 2.81901C1 3.13987 1 3.55991 1 4.39999V8.59999C1 9.44007 1 9.86011 1.16349 10.181C1.3073 10.4632 1.53677 10.6927 1.81901 10.8365C2.13988 11 2.55992 11 3.4 11H7.6C8.44008 11 8.86012 11 9.18099 10.8365C9.46323 10.6927 9.6927 10.4632 9.83651 10.181C10 9.86011 10 9.44007 10 8.59999V6.49999M3.99999 7.99999H4.83726C5.08185 7.99999 5.20414 7.99999 5.31923 7.97236C5.42127 7.94786 5.51881 7.90746 5.60828 7.85263C5.7092 7.79079 5.79568 7.70431 5.96863 7.53136L10.75 2.74999C11.1642 2.33578 11.1642 1.66421 10.75 1.24999C10.3358 0.835778 9.66421 0.835777 9.25 1.24999L4.46862 6.03136C4.29567 6.20431 4.20919 6.29079 4.14735 6.39171C4.09252 6.48118 4.05211 6.57872 4.02762 6.68076C3.99999 6.79585 3.99999 6.91814 3.99999 7.16273V7.99999Z",
    stroke: "#5A52C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.990afeec7168ff7a8082f44872f95c0c.svg";
export { ForwardRef as ReactComponent };